import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Container } from "rsuite"
import { BuildInfoType, getBuildInfo } from "../config/constants"
import { useAuth } from "./AuthProvider"

const demoStyle: React.CSSProperties = {
    background: '#2d6981',
    color: '#e4e4e4',
    width: '100%',
    height: '2em',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'large',
    flex: 0,
    zIndex: 10000,
}
const dailyStyle: React.CSSProperties = {
    background: '#812d6b',
    color: '#e4e4e4',
    width: '100%',
    height: '2em',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'large',
    flex: 0,
    zIndex: 10000,
}

export default function Demo() {
    const { t, i18n } = useTranslation()
    const [info, setInfo] = useState<BuildInfoType | null>(null)

    useEffect(() => {
        const _ = async () => {
            const _info = await getBuildInfo()
            if (!_info.isDemo && !_info.isDaily) return null

            const date = new Date(_info.date || '');

            const lang = i18n.language || 'en'
            let _date = new Intl.DateTimeFormat(lang, {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            }).format(date);

            _info.date = `(${_date})`
            setInfo(prev => { return { ...prev, ..._info } })
        }
        _()
    }, [i18n.language])

    return (
        <>
            {info?.isDemo && <Container style={demoStyle}>
                {t('Demo version')}
            </Container>
            }
            {info?.isDaily && <Container style={dailyStyle}>
                Nightly build {info?.date}
            </Container>
            }
        </>
    )
}